import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GroupService } from 'src/app/services/group/group.service';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';
import { Group } from 'src/app/models/group';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GroupDeleteModel } from 'src/app/models/group-delete-model';

@Component({
  selector: 'app-grupo-list',
  templateUrl: './grupo-list.component.html',
  styleUrls: ['./grupo-list.component.css']
})
export class GrupoListComponent implements OnInit {

  public currentUser;
  public groups: Array<Group>;
  private groupToDelete: Group;

  constructor(
      private router: Router,
      private groupService: GroupService,
      private alertService: NewAlertService,
      private modalService: NgbModal) {
    this.currentUser = JSON.parse(localStorage.getItem(LocalStoreKeys.currentUser));
   }

  ngOnInit() {
      this.buscarGrupos();
  }

  createGroup() {
    this.router.navigate(['portal/grupos/create']);
  }

  buscarGrupos() {
      this.groupService.getGroupsByCedente(this.currentUser.token.assignorGuid).subscribe(response => {
          if (response.status === 1) {
              this.groups = response.result;
          }
      });
  }

  detalhesGrupo(item) {
    sessionStorage.setItem('Grupo', JSON.stringify(item));
    this.router.navigate(['portal/grupos/detalhe']);
  }

  deleteGroup() {
    const groupDeleteModel = new GroupDeleteModel();
    groupDeleteModel.assignorGuid = this.currentUser.token.assignorGuid;
    groupDeleteModel.managerGuid = this.currentUser.token.userReferenceId;



    this.groupService.deleteGroup(groupDeleteModel, this.groupToDelete.guidID).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.alertService.success('Grupo deletado com sucesso');
          this.buscarGrupos();
        } else {
          this.alertService.warning(response.message);
        }
      }, error => {
        this.alertService.error('Erro ao deletar o grupo');
      }

    );
  }

  showModalDeleteGroup(content: any, group: Group) {
    this.groupToDelete = group;
    this.modalService.open(content, { centered: true });
  }

}
